<script setup lang="ts">
import { useArticleLightbox, type LightboxItem } from '@/composables/useArticleLightbox'

// Makes a picture open the article lightbox. Default: wraps the picture in the button.
// `badgeOnly`: just the magnifier, for a video or audio that has its own controls and
// cannot sit inside a button.
defineProps<{ item: LightboxItem; label: string; badgeOnly?: boolean; small?: boolean }>()
const { open } = useArticleLightbox()
</script>

<template>
  <button
    type="button"
    :aria-label="`Enlarge: ${label}`"
    class="cursor-zoom-in"
    :class="badgeOnly ? 'absolute right-1 top-1 z-10 inline-flex items-center justify-center w-11 h-11' : 'relative block w-full'"
    @click="open(item, $event)"
  >
    <slot />
    <span
      class="pointer-events-none flex items-center justify-center rounded-full bg-surface-950/80 text-surface-100"
      :class="[small ? 'w-5 h-5' : 'w-8 h-8', badgeOnly ? '' : small ? 'absolute right-1 bottom-1' : 'absolute right-2 bottom-2']"
      aria-hidden="true"
    >
      <svg :class="small ? 'w-3 h-3' : 'w-4 h-4'" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8.5" cy="8.5" r="5.5" /><path d="M13 13l4 4M8.5 6v5M6 8.5h5" /></svg>
    </span>
  </button>
</template>
